import { render, staticRenderFns } from "./TickButton.vue?vue&type=template&id=10a474be&"
import script from "./TickButton.vue?vue&type=script&lang=js&"
export * from "./TickButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports